var React = require('react');

function Links (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM5.5,4.7","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM11.2,6.1c0,0-1.1-1.9-3.2-1.9S4.7,5.8,4.7,5.8L1.6,9.2c-1.4,1.4-1.4,3.8,0,5.2s3.8,1.4,5.2,0l0.9-0.8","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM4.8,9.9c0,0,1.1,1.9,3.2,1.9s3.4-1.5,3.4-1.5l3.1-3.4c1.4-1.4,1.4-3.8,0-5.2s-3.8-1.4-5.2,0L8.3,2.4","key":2})]));
}

Links.displayName = "Links";

Links.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Links;

Links.default = Links;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/links.svg
// module id = ../icon/src/icons/links.svg
// module chunks = 0